import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  MdLogin,
  MdDashboard,
  MdHistory,
  MdMenu,
  MdClose,
  MdPayments,
  MdPeople
} from "react-icons/md";
import avatarImg from "../../images/shapes/Profile_Logo 1.png";

function AccountAdminSideBar({ user, onLogout }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNavClick = () => {
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  return (
    <>
      <aside className={`sidebar_container1 ${mobileOpen ? "expanded" : ""}`}>
        {/* Profile Header */}
        <div className="profile1">
          <img
            src={user?.avatar || avatarImg}
            alt="Profile"
            className="profile-img1"
          />

          <div className="profile-info1">
            <h3 className="profile-name1">{user?.firstName || "Account Admin"}</h3>
            <p className="profile-role1">{user?.role || "Admin"}</p>
          </div>

          <button
            className="sidebar-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <MdClose /> : <MdMenu />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-content">
          <ul className="menu1">
            <li>
              <NavLink
                to="/account-admin"
                end
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdDashboard className="icon1" />
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/account-admin/users"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdPeople className="icon1" />
                Manage Users
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/account-admin/history"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdHistory className="icon1" />
                TopCoin Distribution
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/account-admin/requests"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdPayments className="icon1" />
                Cashback Requests
              </NavLink>
            </li>
          </ul>

          <div className="bottom-menu1">
            <hr />
            <button
              className="logout-btn1"
              onClick={onLogout}
            >
              <MdLogin className="icon1" /> Logout
            </button>
          </div>
        </nav>
      </aside>
    </>
  );
}

export default React.memo(AccountAdminSideBar);
